var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pod-status" }, [
    _vm.docket.containsPOD === true && _vm.docket.goodPod === false
      ? _c("span", { staticClass: "text-danger" }, [
          _c("i", { staticClass: "fas fa-times" }),
          _vm._v(" Bad\n  ")
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.docket.containsPOD === true && _vm.docket.goodPod === null
      ? _c("span", { staticClass: "text-primary" }, [
          _c("i", { staticClass: "fas fa-exclamation-triangle" }),
          _vm._v("  Unverified\n  ")
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.docket.containsPOD === true && _vm.docket.goodPod === true
      ? _c("span", { staticClass: "text-success" }, [
          _c("i", { staticClass: "fas fa-check" }),
          _vm._v(" Good\n  ")
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.docket.containsPOD === false && _vm.docket.cancelled === false
      ? _c("span", { staticClass: "text-info" }, [
          _c("i", { staticClass: "fas fa-file-exclamation" }),
          _vm._v(" Pending\n  ")
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.docket.cancelled === true
      ? _c("span", { staticClass: "text-warning" }, [
          _c("i", { staticClass: "fas fa-ban" }),
          _vm._v(" Cancelled\n  ")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63de5edd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63de5edd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/PODStatus.vue
// module id = null
// module chunks = 